<template>
  <v-navigation-drawer app clipped v-model="drawer" :expand-on-hover="mini" permanent>
    <v-list>
      <v-list-group v-for="item in menu" :key="item.text">
        <template v-slot:activator>
          <v-list-item-icon v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item v-for="child in item.subActions" :key="child.text" :to="child.link">
          <v-list-item-icon><v-icon>{{ child.icon }}</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ child.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

export default{
  // props: {
  //   drawer: Boolean
  // },

  data: () => ({
    drawer: null
  }),

  computed: {
    mini(){
      return this.$vuetify.breakpoint.mdAndDown
    },

    menu(){
      return [
        {
          text: 'Корпорации',
          expanded: false,
          icon: 'mdi-tablet-dashboard',
          subActions: [
            {
              text: 'Список',
              link: '/corporations',
              expanded: false
            },
          ]
        },
        {
          text: 'Объекты',
          expanded: false,
          icon: 'mdi-store',
          subActions: [
            {
              text: 'Список',
              link: '/shops',
              expanded: false
            },
            {
              text: 'Добавить',
              link: '/shops/add',
              expanded: false
            },
          ]
        }
      ]
    }
  }
}
</script>